import { type ReactNode } from 'react';
import { type GridApi } from '@ag-grid-community/core';
import { type ICSAgGridProps } from '../ICSAgGrid';
import { ICSGridActions } from './ICSGridActions';
import { ICSGridSearch } from './search/ICSGridSearch';
import { useDetailSearchTarget } from './ICSGridActionsContext';
import s from './grid-controls.module.scss';

type ICSGridControlsProps<TData> = Partial<ICSAgGridProps<TData>> & {
    api?: GridApi<TData>;
};

export function ICSGridControls<TData>(
    props: ICSGridControlsProps<TData>,
): ReactNode {
    const { hideSearch } = props;
    const detailSearchTarget = useDetailSearchTarget();
    const searchProps = detailSearchTarget
        ? {
              ...props,
              api: detailSearchTarget.api as GridApi<TData>,
              columnDefs: detailSearchTarget.columnDefs,
          }
        : props;

    return (
        <div className={s.gridControls}>
            {hideSearch ? null : (
                <div className="w-full">
                    <ICSGridSearch {...searchProps} />
                </div>
            )}
            <ICSGridActions {...props} />
        </div>
    );
}
